import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { Nav, NavbarContainer, NavLogo, NavLogoImg, HamburgerIcon, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink } from './NavbarElements';
import Logo from '../../images/logo-szsem.png'


const Navbar = ({ toggle }) => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollNav(true);
        } else {
            setScrollNav(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, [])

    return (
        <>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo smooth={true} duration={500} spy={true} exact="true" offset={-80} to='home'><NavLogoImg src={ Logo } />Strona Promująca</NavLogo>
                    <HamburgerIcon onClick={ toggle }>
                        <FaBars />
                    </HamburgerIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks smooth={true} duration={500} spy={true} exact="true" offset={-80} to="about">O Stowarzyszeniu</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks smooth={true} duration={500} spy={true} exact="true" offset={-80} to="projects">Projekty</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks smooth={true} duration={500} spy={true} exact="true" offset={-80} to="contact">Kontakt</NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavBtn>
                        <NavBtnLink smooth={true} duration={500} spy={true} exact="true" offset={-80} to="support1Per">
                            Wesprzyj Stowarzyszenie
                        </NavBtnLink>
                        </NavBtn>
                </NavbarContainer>
            </Nav>
        </>
    )
}

export default Navbar;
